module.exports = __webpack_public_path__ + "img/checkbox_icon.63bb0c76.svg";